import { format, parseISO } from 'date-fns';
import { de } from 'date-fns/locale';

/**
 * Formats a date into a readable string
 * @param date The date to format
 * @param formatStr The format string (default: 'dd.MM.yyyy')
 * @param locale The locale to use (default: German)
 * @returns Formatted date string
 */
export function formatDate(date: Date | string, formatStr = 'dd.MM.yyyy', locale = de): string {
  if (!date) return '';
  
  const dateObj = typeof date === 'string' ? parseISO(date) : date;
  return format(dateObj, formatStr, { locale });
}

/**
 * Formats a date specifically for email display
 * @param date The date to format
 * @returns Formatted date string for emails
 */
export function formatEmailDate(date: Date | string): string {
  return formatDate(date, 'EEEE, dd. MMMM yyyy, HH:mm');
}

/**
 * Formats a date range as a string
 * @param startDate The start date
 * @param endDate The end date (optional)
 * @returns Formatted date range string
 */
export function formatDateRange(startDate: Date | string, endDate?: Date | string): string {
  if (!endDate) {
    return formatDate(startDate);
  }
  
  const start = formatDate(startDate, 'dd.MM.yyyy');
  const end = formatDate(endDate, 'dd.MM.yyyy');
  
  return `${start} - ${end}`;
}